import { startRemoveSplashScreen } from "./RemoveSplashScreen";

export const startLocalConsumers = () => {
  startRemoveSplashScreen();
};

export default startLocalConsumers;
